import {type ModelbankMeta} from '@/types/product-media';

export const MODELBANK_META = new Map<string, ModelbankMeta>([
    [
        'silo',
        {
            mediaKind: 'Products::Silo',
            endpoints: {
                create: 'api/v1/jobs.json',
                calculateCreditCost: 'api/v1/jobs/credit_cost.json',
            },
        },
    ],
    [
        'spin',
        {
            mediaKind: 'Products::Spin360',
            endpoints: {
                create: 'api/v1/jobs.json',
                calculateCreditCost: 'api/v1/jobs/credit_cost.json',
            },
        },
    ],
    [
        'mask-silo',
        {
            mediaKind: 'Products::MaskSilo',
            endpoints: {
                create: 'api/v1/jobs.json',
                calculateCreditCost: 'api/v1/jobs/credit_cost.json',
            },
        },
    ],
    [
        'lifestyle',
        {
            mediaKind: 'Products::Lifestyle',
            endpoints: {
                create: 'api/v1/jobs.json',
                indexLifestyle: 'api/v1/ai_lifestyles/results',
                generateLifestyle: 'api/v1/ai_lifestyles/generate_banana',
                getPresignedUrl: 'api/v1/ai_lifestyles/presigned_upload',
                calculateCreditCost: 'api/v1/jobs/credit_cost.json',
            },
        },
    ],
]);
